import { supplierIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const SupplierContactSchema_ = z.object({
  name: z.string(),
  email: z.string().nullable(),
  phoneNumber: z.string().nullable(),
});

export const SupplierContactSchema: z.ZodType<SupplierContactSchema> =
  SupplierContactSchema_;
export interface SupplierContactSchema
  extends z.infer<typeof SupplierContactSchema_> {}

const SupplierSchema_ = z.object({
  id: supplierIdFormat.schema,
  name: z.string(),
  street1: z.string().nullable(),
  street2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  website: z.string().nullable(),
  currency: z.string().nullable(),
  productVendors: z.array(z.string()),
  leadTimeDays: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contacts: z.array(SupplierContactSchema),
  defaultPoTemplateId: z.string().nullable(),
});

export const Supplier: z.ZodType<Supplier> = SupplierSchema_;
export interface Supplier extends z.infer<typeof SupplierSchema_> {}

export const getSuppliers = {
  name: "getSuppliers" as const,
  input: z.object({}),
  output: z.object({ suppliers: z.array(Supplier) }),
};
